import Api from '@umu/umu-api';
import { fetchData } from '@umu/umu-fetch';

interface ParamsType {
    id: string;
    enterprise_id: string;
    invite_status: number;
}

export async function setEnterpriseInviteStatus(params: ParamsType) {
    const { id, enterprise_id, invite_status } = params;

    /**
     * 0 : 待确认
     * 1 : 确认
     * 2 : 拒绝 
     */ 

    if (invite_status == 2) {
        await fetchData(Api.Path.SET_MESSAGE_STATUS, {
            id,
            invite_status,
        });
        await fetchData(Api.Path.REJECT_JOIN_ENTERPRISE, {
            id,
            enterprise_id,
        });
    } else if (invite_status == 0) {
        await fetchData(Api.Path.READ_DIALOG, {
            obj_id: id,
            obj_type: 'invite_to_join_enterprise_show',
        });
    } else {
        await fetchData(Api.Path.DOACTIVATE, {
            enterprise_id,
        });
        await fetchData(Api.Path.SET_MESSAGE_STATUS, {
            id,
            invite_status,
        });
    }
}
